<form #form="ngForm" autocomplete="off" *ngIf="reservationQuestions">
    <div *ngFor="let reservationQuestion of reservationQuestions; let i = index">
        <div [ngClass]="{'blue-background': reservationQuestion.questionType == ReservationQuestionType.Email ||
        reservationQuestion.questionType == ReservationQuestionType.PhoneNumber }">
            <span *ngIf="reservationQuestion.questionType == ReservationQuestionType.FirstName ||
                reservationQuestion.questionType == ReservationQuestionType.LastName">
                <span class="text-danger" *ngIf="reservationQuestion.isRequired">*</span>
                {{ reservationQuestion.question }}
            </span>

            <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.Text
                || reservationQuestion.questionType == ReservationQuestionType.FirstName
                || reservationQuestion.questionType == ReservationQuestionType.LastName">
                <input class="form-control" [(ngModel)]="reservationQuestion.answer" #text="ngModel" name="text{{i}}"
                    [required]="reservationQuestion.isRequired" (keydown)="preventNumber($event)"
                    (ngModelChange)="updateTicketReservation(form.invalid)" (input)="checkForUrls(reservationQuestion.answer)">
                <div *ngIf="text.invalid && (text.dirty || text.touched)" class="text-danger">
                    <div *ngIf="text.errors.required">
                        {{ 'required' | translate }}
                    </div>
                </div>
                <div *ngIf="textInvalid" class="text-danger">
                    {{ 'invalid-text' | translate }}
                </div>
            </div>

            <!-- TODO: update personal ID validation -->
            <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.PersonalID">
                <input class="form-control" [(ngModel)]="reservationQuestion.answer" #personalID="ngModel" name="personalID"
                    [required]="reservationQuestion.isRequired" pattern="^[0-9]{11}$" (ngModelChange)="updateTicketReservation(form.invalid)">
                <div *ngIf="personalID.invalid && (personalID.dirty || personalID.touched)" class="text-danger">
                    <div *ngIf="personalID.errors.required">
                        {{ 'personal-id-required' | translate }}
                    </div>
                    <div *ngIf="personalID.errors.pattern">
                        {{ 'invalid-personal-id' | translate }}
                    </div>
                </div>
            </div>

            <div class="blue-background">
                
                <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.Email">
                    
                    <div class="info">{{ 'info' | translate }}</div>

                    <span class="text-danger" *ngIf="reservationQuestion.isRequired">*</span>
                    {{ reservationQuestion.question }}
                    
                    <input class="form-control" [(ngModel)]="reservationQuestion.answer" #email="ngModel" name="email"
                        [required]="reservationQuestion.isRequired" email (ngModelChange)="updateTicketReservation(form.invalid)">
                    <div *ngIf="email.invalid && (email.dirty || email.touched)" class="text-danger">
                        <div *ngIf="email.errors.required">
                            {{ 'email-required' | translate }}
                        </div>
                        <div *ngIf="email.errors.email">
                            {{ 'invalid-email' | translate }}
                        </div>
                    </div>
                </div>
            
                <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.PhoneNumber">
                    
                    <span class="text-danger" *ngIf="reservationQuestion.isRequired">*</span>
                    {{ reservationQuestion.question }}
                    
                    <input class="form-control" [(ngModel)]="reservationQuestion.answer" #phone="ngModel" name="phone"
                        [required]="reservationQuestion.isRequired"  minlength="7" maxlength="17" (keydown)="validateNumber($event)"
                        pattern="^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$" (ngModelChange)="updateTicketReservation(form.invalid)">
                    <div *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="text-danger">
                        <div *ngIf="phone.errors.required">
                            {{ 'phone-number-required' | translate }}
                        </div>
                        <div *ngIf="phone.errors.pattern || phone.errors.minlength">
                            {{ 'invalid-phone-number' | translate }}
                        </div>
                    </div>
                </div>

            </div>

            <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.Client">
                <mat-form-field>
                    <mat-label>{{ reservationQuestion.question }}</mat-label>
                    <mat-select matNativeControl name="client" #client="ngModel" [(ngModel)]="reservationQuestion.answer" required
                        (selectionChange)="updateTicketReservation(form.invalid)" disableOptionCentering>
                        <mat-option value="individual-client">{{ 'individual-client' | translate }}</mat-option>
                        <mat-option value="business-client">{{ 'business-client' | translate }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.Case">
                <mat-form-field>
                    <mat-label>{{ reservationQuestion.question }}</mat-label>
                    <mat-select matNativeControl name="case" #case="ngModel" [(ngModel)]="reservationQuestion.answer" required
                        (selectionChange)="updateTicketReservation(form.invalid)" disableOptionCentering>
                        <mat-option *ngIf="!reservationPluginService.getIsOperator()" value="agreements-conclusion-changes">
                            {{ 'agreements-conclusion-changes' | translate }}</mat-option>
                        <mat-option *ngIf="!reservationPluginService.getIsOperator()" value="offers-promotions">
                            {{ 'offers-promotions' | translate }}</mat-option>
                        <mat-option *ngIf="!reservationPluginService.getIsOperator()" value="technical-matters">
                            {{ 'technical-matters' | translate }}</mat-option>
                        <mat-option *ngIf="!reservationPluginService.getIsOperator()" value="invoices-payments">
                            {{ 'invoices-payments' | translate }}</mat-option>
                        <mat-option *ngIf="reservationPluginService.getIsOperator()" value="connecting-to-network">
                            {{ 'connecting-to-network' | translate }}</mat-option>
                        <mat-option *ngIf="reservationPluginService.getIsOperator()" value="customer-with-distribution-contract">
                            {{ 'customer-with-distribution-contract' | translate }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
</form>
